import { apiCallWrapper } from 'traveldesk-ui'
import { SelectOptionModel } from 'traveldesk-ui'
import City, { CityWithCountryModel } from '../models/City'

export default class CitiesApiService {
    
    public static async getCitiesInCountries(dispatch: any, countryIds: number[]) {
        let url = '/api/cities/incountries'
        if (countryIds.length > 0) {
            url += `?${countryIds.map(countryId => `countriesIds=${encodeURIComponent(countryId)}`).join('&')}`
        }
        return await apiCallWrapper<CityWithCountryModel[]>(url, 'GET', dispatch)
    }
    public static async getCitiesInSuppliersCountry(dispatch: any) {
        const res = await apiCallWrapper<SelectOptionModel[]>('/api/cities/supplier', 'GET', dispatch)
        return res
    }
 

   public static async GetCitiesOfOperation(dispatch: any) {
        const res = await apiCallWrapper<City[]>('/api/suppliers/cities', 'GET', dispatch)
        return res
    }
}